module.exports = __webpack_public_path__ + "static/media/Default.21fc08f1.webp";